module.exports = __webpack_public_path__ + "static/media/info-circleBlack.e5665ea4.svg";